export const auth = {
    PPCP_ADMINISTRAR: 'PPCP_ADMINISTRAR',
    PPCP_PLANEJADOR: 'PPCP_PLANEJADOR',
    PPCP_VISUALIZADOR: 'PPCP_VISUALIZADOR',
};

export const modoOperacao = {
    PRODUCAO: 'PRODUCAO',
    REPOSICAO: 'REPOSICAO',
};

export const intervaloGeral = {
    INTERVALO_GERAL: 50,
};
